import roundTo from 'round-to';
import { getWorldRegionsAggObject } from '../WorldMapConstants';
import { getOutput } from './General';

const country_alpha_id_mapper = require('../../../../assets/worldmap/compact_country_alpha_id_mapper.json');

export function processPlaytimeAdapter(countries) {
   const adaptedCountries = countries.map((countryBucket) => {
      const { country, alpha2, averagePlaybackTime, totalUniquePlaybacks } = countryBucket;
      const { coordinates, worldRegion, code } = country_alpha_id_mapper[alpha2];
      const coor = [coordinates.longitude, coordinates.latitude];
      return {
         alpha: alpha2,
         coor,
         id: code.numeric,
         name: country,
         worldRegion,
         playtime: averagePlaybackTime.seconds,
         total: totalUniquePlaybacks.count,
      };
   });

   const worldRegions = createWorldRegionsAndTopData(adaptedCountries);

   return getOutput(adaptedCountries, worldRegions);
}

function createWorldRegionsAndTopData(countries) {
   const worldRegions = getWorldRegionsAggObject({
      uniquePlaybacksWeightedPlaytime: 0,
      totalUniquePlaybacks: 0,
   });

   countries.forEach((country) => {
      const { worldRegion, playtime, total } = country;
      worldRegions[worldRegion].totalUniquePlaybacks += total;
      worldRegions[worldRegion].uniquePlaybacksWeightedPlaytime += total * playtime;
      worldRegions[worldRegion].countries.push(country);
   });

   Object.keys(worldRegions).forEach((worldRegion) => {
      worldRegions[worldRegion].playtime = roundTo(
         worldRegions[worldRegion].uniquePlaybacksWeightedPlaytime / worldRegions[worldRegion].totalUniquePlaybacks,
         1,
      );
      worldRegions[worldRegion].total = worldRegions[worldRegion].totalUniquePlaybacks;
      delete worldRegions[worldRegion].uniquePlaybacksWeightedPlaytime;
      delete worldRegions[worldRegion].totalUniquePlaybacks;
   });

   return worldRegions;
}
